/* eslint-disable */
import {ConfiguratorBase} from './ConfiguratorBase';
import {ReactComponent} from './ReactComponent';
import {Price} from './Price';
import {IQuantity} from './IQuantity';
import {ProductPdf} from './ProductPdf';
export interface IInstallationAddonProduct {
	type: InstallationProducType;
	productId: string;
	title: string;
	price: Price;
	selected: boolean;
	quantity: IQuantity;
}
export interface IZipFetchInstallationProduct extends IInstallationAddonProduct {
	installationId: string;
}
export enum InstallationProducType {
	PolarPump = 0,
	Lawnmower = 1,
	Vvs = 2,
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.InstallationConfigurator
*/
export interface InstallationConfigurator extends ConfiguratorBase {
	installation: InstallationAddonGroup;
	addons?: InstallationAddonGroup;
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.PolarpumpInstallationConfigurator
*/
export interface PolarpumpInstallationConfigurator extends InstallationConfigurator {
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.LawnMowerInstallationConfigurator
*/
export interface LawnMowerInstallationConfigurator extends InstallationConfigurator {
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.VvsInstallationConfigurator
*/
export interface VvsInstallationConfigurator extends InstallationConfigurator {
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.ZipCodeExcludeConfigurator
*/
export interface ZipCodeExcludeConfigurator extends InstallationConfigurator {
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.InstallationAddonGroup
*/
export interface InstallationAddonGroup {
	name: string;
	description: ReactComponent;
	products: IInstallationAddonProduct[];
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.PolarPumpAddonProduct
*/
export interface PolarPumpAddonProduct {
	type: InstallationProducType;
	productId: string;
	title: string;
	price: Price;
	selected: boolean;
	quantity: IQuantity;
	zipCodeRanges: string[];
	pdf: ProductPdf;
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.LawnMowerAddonProduct
*/
export interface LawnMowerAddonProduct {
	type: InstallationProducType;
	productId: string;
	title: string;
	price: Price;
	selected: boolean;
	quantity: IQuantity;
	installationId: string;
	description: ReactComponent;
}
/**
* @description Interface for Avensia.Commerce.Web.src.views.ProductPage.configurators.polarpumpen.VvsInstallationProduct
*/
export interface VvsInstallationProduct {
	type: InstallationProducType;
	productId: string;
	title: string;
	price: Price;
	selected: boolean;
	quantity: IQuantity;
	installationId: string;
	pdf: ProductPdf;
}
